var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-mobile g-10"},_vm._l((_vm.filters.filters),function(filter){return _c('CButton',{key:filter.name,attrs:{"properties":filter.button},on:{"click":function($event){return _vm.selectFilter(filter)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }